import { render, staticRenderFns } from "./ConfigurationCard.vue?vue&type=template&id=541e4f25&scoped=true"
import script from "./ConfigurationCard.vue?vue&type=script&lang=js"
export * from "./ConfigurationCard.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationCard.vue?vue&type=style&index=0&id=541e4f25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541e4f25",
  null
  
)

export default component.exports